// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/create-widget-host-config-request-schema',
  type: 'object',
  required: ['id', 'creatorId', 'name', 'hostKey', 'languageIso2', 'locale'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    name: {
      type: 'string',
      minLength: 3,
      maxLength: 100,
    },
    hostKey: {
      type: 'string',
      minLength: 1,
      maxLength: 100,
    },
    loaderUrl: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    allowedReferers: {
      type: 'string',
      nullable: true,
      maxLength: 500,
    },
    languageIso2: {
      type: 'string',
      minLength: 1,
      maxLength: 2,
    },
    locale: {
      type: 'string',
      minLength: 2,
      maxLength: 5,
    },
    entryPoint: {
      type: 'string',
      nullable: true,
      maxLength: 100,
    },
    navigation: {
      type: 'string',
      nullable: true,
      maxLength: 50,
    },
    startParameters: {
      type: 'string',
      nullable: true,
    },
    apiKey: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    isDebug: {
      type: 'boolean',
    },
    isActive: {
      type: 'boolean',
    },
    textContentScope: {
      type: 'string',
      nullable: true,
      maxLength: 150,
    },
  },
} as IJSONSchema;

export default schema;
